import "../styles/ImageCard.css";

export default function ImageCard({ imageSrc, altText, title, description }) {
  return (
    <div className="image-card">
      <img src={imageSrc} alt={altText} className="image-card-image" />
      {title && <h3 className="image-card-title">{title}</h3>}
      {description && <p className="image-card-description">{description}</p>}
    </div>
  );
}
